<template>
    <div class="">

        <el-dialog
        width="55%"
        :title="dialogTitle"
        :close-on-click-modal="false"
        :append-to-body="true"
        :visible="goodsVisible"
        @close="closeDialog">
            <el-alert
                title="货物名称不能相同,选择货物最小出库单位为货物单位。"
                :closable="false"
                style="margin-bottom: 20px;"
                type="warning">
            </el-alert>
            <el-card style="margin-bottom: 30px;">
                
                <el-form ref="goodsForm" :model="goodsForm" :rules="goodsRules" label-width="100px">
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物类别" required prop="goodsClassCode">
                                <el-cascader
                                style="width: 100%"
                                v-model="goodsForm.goodsClassCode"
                                :props="{ label: 'goodsClassName', value: 'goodsClassCode', emitPath: false }"
                                :options="classOptions"></el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物名称" required prop="goodsName">
                                <el-input v-model="goodsForm.goodsName" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="品牌" required prop="goodsBrand">
                                <el-input v-model="goodsForm.goodsBrand" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物型号" required prop="goodsType">
                                <el-input style="width: 100%" v-model="goodsForm.goodsType" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        
                        <el-col :span="11">
                            <el-form-item label="生产厂商" required prop="manufacturer">
                                <el-input style="width: 100%" v-model="goodsForm.manufacturer" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="货物单位" required prop="goodsUnit">
                                <el-select style="width: 100%" v-model="goodsForm.goodsUnit" placeholder="请选择">
                                    <el-option v-for="(item,i) in unitList" :value="item" :label="item">{{item}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="100">
                        <el-col :span="11">
                            <el-form-item label="货物配置" required prop="goodsConfig">
                                <el-input style="width: 100%" :rows="4" type="textarea" v-model="goodsForm.goodsConfig" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="11">
                            <el-form-item label="备注" prop="remarks">
                                <el-input style="width: 100%" :rows="4" type="textarea" v-model="goodsForm.remarks" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
            <span slot="footer" class="dialog-footer">
                <el-button @click="goodsVisible = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit">确 定</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">

            <el-form class="queryRow" inline>
                <el-form-item label="货物分类" class="queryCol">
                    <el-cascader
                    style="width: 100%"
                    v-model="queryForm.goodsClassCode"
                    :props="{ label:'goodsClassName',value: 'goodsClassCode', emitPath: false, checkStrictly: true }"
                    :options="classOptions"
                    @change="onSearch"
                    clearable
                    @clear="onSearch">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="货物名称" class="queryCol">
                    <el-input placeholder="请输入" clearable @clear="onSearch" v-model="queryForm.goodsName"></el-input>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>

            <el-button type="primary" icon="el-icon-plus" @click="handleAdd">
                添加货物
            </el-button>
        </div>
        

        <el-table
        v-loading="loading"
        class="table"
        :row-style="{ height: '50px' }"
        style="width: 100%; height: 65vh; overflow: auto;"
        :data="goodsList">
            <el-table-column
                label="选择"
                v-if="claimDialogType === 'add'"
                width="55">
                <template slot-scope="scope">
                    <el-popover
                    v-if="scope.row.overSelect"
                    placement="top-start"
                    width="30"
                    trigger="hover"
                    content="已在请购的货物列表中">
                        <i slot="reference"  class="el-icon-success" style="color: #67C23A; font-size: 18px;"></i>
                    </el-popover>
                    <el-checkbox v-else v-model="scope.row.checked"></el-checkbox>
                </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="货物名称"
                prop="goodsName">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物类别"
                prop="goodsClassName">
            </el-table-column>
            <el-table-column
                align="center"
                label="品牌"
                prop="goodsBrand">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物型号"
                prop="goodsType">
            </el-table-column>
            <el-table-column
                align="center"
                label="生产厂商"
                prop="manufacturer">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物配置"
                prop="goodsConfig">
                <template slot-scope="scope"> 
                    <el-popover trigger="hover" placement="top" width="300">
                        <p>{{ scope.row.goodsConfig }}</p>
                            <div slot="reference">
                            <p size="medium" style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">{{ scope.row.goodsConfig}}</p>
                        </div>
                    </el-popover>        
                </template>
            </el-table-column>
            <el-table-column align="center" label="库存数量" prop="whGoodsNum" width="100">
            </el-table-column>
            <el-table-column
                align="center"
                label="货物单位"
                prop="goodsUnit">
            </el-table-column>
            
            <el-table-column
                align="center"
                v-if="claimDialogType === 'edit'"
                label="选择"
                prop="operate">
                <template slot-scope="scope">
                    <el-popover
                    v-if="scope.row.overSelect"
                    placement="top-start"
                    width="30"
                    trigger="hover"
                    content="已在请购的货物列表中">
                        <i slot="reference"  class="el-icon-success" style="color: #67C23A; font-size: 18px;"></i>
                    </el-popover>
                    <el-button type="text" v-else icon="el-icon-position"  @click="selectOnce(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination
            @size-change="onSizeChange"
            @current-change="onCurrentChange"
            :total="total"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100]"
            :current-page="page"
            background
            layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>

        <!-- <div class="dialog-footer" style="display: flex; justify-content: flex-end; margin-top: 10px;">
            <el-button type="primary" @click="submitAddGoods" >确 定</el-button>
        </div> -->
        
    </div>
</template>
<script>
import { postProvinces, postCitys } from "@/api/SlmsData/Supplier";
import { getGoodsClassList, getGoodsByPage, addGoods, deleteGoods, updateGoods, getUnits } from '@/api/goods/goodsBusiness.js';
export default {
   data() {
      return {
        goodsList: [], // 货物列表
        goodsForm: {}, // 表单数据
        goodsRules:{
            goodsClassCode: [
                { required: true, message: '请选择货物类型' }
            ],
            goodsName: [
                { required: true, message: '请输入货物名称' }
            ],
            goodsBrand: [
                { required: true, message: '请输入货物品牌' }
            ],
            goodsBrand: [
                { required: true, message: '请输入货物品牌' }
            ],
            goodsType: [
                { required: true, message: '请输入货物型号' }
            ],
            goodsConfig:[
                { required: true, message: '请输入货物配置' }
            ],
            manufacturer:[
                { required: true, message: '请输入生成厂商' }
            ],
            goodsUnit:[
                { required: true, message: '请选择货物单位' }
            ]
        }, // 表单校验
        loading: false, // 加载中
        classOptions: [],
        queryForm: {
            category: '行政', // 货物类别
            provinceCode: '', // 省份
            cityCode: '' // 城市
        }, // 查询表单
        total: 0, // 总条目数
        pageSize: 10,
        page: 1,
        goodsVisible: false, // 货物表单显隐
        unitList: [], // 单位列表
        dialogTitle: '', // 弹窗标题
      }
   },
   async created(){
        await this.getGoodsList();
        await this.getGoodsClassList();
        this.getUnitList();
   },
   props:{
        claimDialogType: {
            type: String,
        }
   },
   computed:{
   },
   methods:{
   //获取当前日期
   
    // 选择单个货物
    selectOnce(row){
        this.$confirm('是否选择该货物', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
        }).then(({ value }) => {
            let rowData = {...row};
            rowData.goodsNum = Number(value);
            this.$emit('checkGoods',rowData);
        })
    },
    // 提交选择的货物
    submitAddGoods(){
        let selectionList = []; // 选择的库存中货物
        this.goodsList.forEach(item => {
            if(item.checked) {
                let newItem = {...item};
                newItem.goodsNum = 1;
                selectionList.push(newItem);
            }
        })
        if(selectionList.length === 0){
            this.$message({
                type:'error',
                message: '未选择新的货物'
            });
            return;
        }
        this.$emit('checkGoods',selectionList);
    },
    // 选择货物
    checkGoods(item){
        this.$emit('checkGoods',item);
    },
    // 关闭弹窗
    closeDialog(){
        this.goodsForm = {};
        this.$refs['goodsForm'].resetFields();
        this.goodsVisible = false;
    },
    // 获取单位列表
    getUnitList(){
        getUnits().then(res => {
            if(res.code === 200){
                this.unitList = res.data;
            }
        })
    },
    // 点击修改按钮
    handleEdit(item){
        this.dialogTitle = '修改货物信息';
        this.goodsForm = {...item};
        this.goodsVisible = true;
    },
    // 点击新增
    handleAdd(item){
        this.dialogTitle = '新增货物';
        this.goodsVisible = true;
    },
    // 获取货物列表
    async getGoodsList(){
        this.loading = true;
        await getGoodsByPage({
            goodsClassCode: this.queryForm.goodsClassCode,
            goodsName: this.queryForm.goodsName,
            category: this.queryForm.category,
            page: this.page,
            limit: this.pageSize
        }).then(res => {
            if(res.code === 200){
                this.goodsList = res.data;
                this.total = res.total;
                this.loading = false;
            }
        })
    },
    // 获取货物类别列表
    async getGoodsClassList(){
        await getGoodsClassList({ classFlag: '2' }).then(res => {
            if(res.code === 200){
                this.classOptions = res.data
            }
        })
    },
    // 当每页条数变化
    onSizeChange(e){
        this.page = 1;
        this.pageSize = e;
        this.getGoodsList();
    },
    // 搜索
    onSearch(){
        this.page = 1;
        this.getGoodsList();
    },
    // 当页码发生变化时
    onCurrentChange(e){
        this.page = e;
        this.getGoodsList();
    },
    // 提交表单
    handleSubmit(){
        
        this.$refs.goodsForm.validate((valid) => {
            if(valid){
                if(this.dialogTitle === '新增货物'){
                    addGoods(this.goodsForm).then(res => {
                        if(res.code === 200){
                            this.getGoodsList();
                            this.$message({
                                type: 'success',
                                message: '添加货物成功!'
                            });
                            this.goodsVisible = false;
                        }
                    })
                }else if(this.dialogTitle === '修改货物信息'){
                    updateGoods(this.goodsForm).then(res => {
                        if(res.code === 200){
                            this.getGoodsList();
                            this.$message({
                                type: 'success',
                                message: '修改货物信息成功!'
                            });
                            this.goodsVisible = false;
                        }
                    })
                }
                
            }
        })
    },
    //点击删除
    handleDel(id){
        this.$confirm('确定删除这条货物信息吗?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            deleteGoods({id}).then(res => {
                if(res.code === 200){
                    this.getGoodsList();
                    this.$message({
                        type: 'success',
                        message: '删除货物成功!'
                    });
                }
            })
        })
    }
   },
}
</script>
<style lang="scss" scoped>
.outer{
    .pageination{
        display: flex; 
        justify-content: flex-end;
        margin-top: 5px
    }
    .topSearch{
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }
    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }
    .detailTable{
        ::v-deep .el-checkbox__input{
            &.is-checked{
                .el-checkbox__inner{
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }
    .table{
        ::v-deep .el-table__cell{
            >:empty::before{
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
